import { Injectable, Injector } from '@angular/core';

import { FootprintApiManager_FrontendFlowService } from './FootprintApiManager.frontend.flow.index';


import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FrontendFlowService {

  constructor(
    public FootprintApiManager: FootprintApiManager_FrontendFlowService,
    private injector: Injector
  ) {
  }

  public app: app_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
